import FormBlock from 'components/form/FormBlock';
import FormButtons from 'components/form/FormButtons';
import { RegisterUserRequest, UserPublic } from 'api/model';
import { getRegisterUserFormSchema, getRegisterUserUiSchema } from 'api/auth/formSchema';
import useUsers from 'api/users/useUsers';
import { SettingsFormShell } from 'components/settingsHub/SettingsFormShell';

const FORM_ID = 'user-add-form';

type Props = {
  onCancel: () => void;
  onSubmit: (user: UserPublic) => void;
};

const UserAdd = ({ onCancel, onSubmit }: Props) => {
  const {
    create: { isPending, mutateAsync },
  } = useUsers({ enabled: false });

  const handleSubmit = async (formData: RegisterUserRequest) => {
    const user = await mutateAsync(formData);
    onSubmit(user);
  };

  return (
    <SettingsFormShell
      title="Add User"
      footer={<FormButtons formId={FORM_ID} onCancel={onCancel} isLoading={isPending} submitBtnTxt="Create" />}
    >
      <FormBlock
        onSubmit={(formData) => void handleSubmit(formData as RegisterUserRequest)}
        onCancel={onCancel}
        schema={getRegisterUserFormSchema()}
        uiSchema={getRegisterUserUiSchema()}
        isLoading={isPending}
        formId={FORM_ID}
        showButtons={false}
      />
    </SettingsFormShell>
  );
};

export default UserAdd;
